import { Loader2 } from 'lucide-react';
import { ReactElement } from 'react';

export function FullscreenLoading(): ReactElement {
	return (
		<div className="flex h-full w-full items-center justify-center">
			<Loader2 className="size-10 animate-spin text-primary" />
		</div>
	);
}
